let header1 = document.querySelector('div.header1__customHeader');
let header2 = document.querySelector('div.header2__customHeader');
let bodyE = document.querySelector('div.custom--transparentHeader');
let customIMG = document.querySelector('div.resp-stickyCustom');

document.addEventListener('DOMContentLoaded', ()=>{
  customIMG.classList.add('display--reject')
  let par = document.createElement('div');
  par.setAttribute('class', 'parent--transparent__custom__an');
  par.innerHTML = header1.outerHTML + header2.outerHTML;
  bodyE.prepend(par);
  header1.remove();
  header2.remove();
  
document.addEventListener('scroll', ()=>{
  let h1 = document.querySelector('div.parent--transparent__custom__an div.header1__customHeader header.header.header-classic');
  let h2 = document.querySelector('div.parent--transparent__custom__an div.header2__customHeader div.header-navigation.header-nav-plain');
  let image = document.querySelector('img.custom-imageSwap');
  let links = document.querySelectorAll('nav.header__inline-menu li.menu-lv-item > a.header__menu-item > span.text');
  
  if(window.pageYOffset >= 480){
    let icon_box = document.querySelector('div.header__iconItem.header__group').style.display = "none";
    customIMG.classList.remove('display--reject');
    console.log('removed successfully');
    h1.classList.add('white_color--custom');
    h2.classList.add('white_color--custom');
    image.setAttribute('srcset', 'https://cdn.shopify.com/s/files/1/0898/7800/3993/files/Mysthelle_Logo_2.png?v=1725255472');
    links.forEach((col)=>{
      col.style.color = "#232323";
    })
    bodyE.removeChild(header1);
  } else {
    let icon_box = document.querySelector('div.header__iconItem.header__group').style.display = "flex";
    h1.classList.remove('white_color--custom');
    h2.classList.remove('white_color--custom');
    image.setAttribute('srcset', 'https://cdn.shopify.com/s/files/1/0898/7800/3993/files/Mysthelle_Logo_1_1.png?v=1726114380');
    links.forEach((col)=>{
      col.style.color = "#ffffff";
    })
  }
})
})

